import {
    faCalendarAlt,
    faDatabase,
    faEdit,
    faFilter,
    faPlus,
    faSortNumericUpAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import LazySelect from "../../../../../Components/CardsPages/Forms/LazySelect";
import SpinnerComponent from "../../../../../Components/Loding/Spinner";
import ModalComponent from "../../../../../Components/Modais";
import { IComponentModal } from "../../../../../Components/Modais/IModalComponent";
import Table from "../../../../../Components/Table";
import {
    DeletarAcaoReguaContoller,
    ListarAcoesReguaPorEtapaController,
} from "../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import {
    IAcoesReguaEtapa,
    IRegua,
    IReguaEtapa,
} from "../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";
import ModalAgendamento from "./ModalAgendamento";
import ModalCadastrarAcaoEtapa from "./ModalCadastrarAcaoEtapa";
import ModalEditarAcoes from "./ModalEditarAcoes";
import ModalGerenciarFiltroAcao from "./ModalGerenciarFiltroAcao";
import ModalOrdemAcao from "./ModalOrdemAcao";
import ModalVisualizarDados from "./ModalVisualizarDados";

interface IAcoesDaRegua {
    IdRegua: string;
    LstAcoesEtapaRegua: IAcoesReguaEtapa[] | undefined;
    updateListAcoesReguaPorEtapa: () => void;
    ID_CASO_COBRANCA_REGUA_ETAPA: number;
    setLstAcoesEtapaRegua: Dispatch<
        SetStateAction<IAcoesReguaEtapa[] | undefined>
    >;
    setID_CASO_COBRANCA_REGUA_ETAPA: Dispatch<SetStateAction<number>>;

    show: boolean;
    setShow: Dispatch<SetStateAction<boolean>>;
    modal: IComponentModal | undefined;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;

    setDadosRegua: Dispatch<SetStateAction<IRegua | undefined>>;
    DadosRegua: IRegua | undefined;

    ListarReguaEtapa: () => Promise<IReguaEtapa[]>;
    lstReguaEtapa: IReguaEtapa[] | undefined;

    cadastroEtapaReguaLoading: boolean;

    updateListReguaEtapaLoading: boolean;
}

export default function AcoesDaRegua(props: IAcoesDaRegua) {
    const [idCasoCobrancaReguaEtapa, setIdCasoCobrancaReguaEtapa] = useState(
        props.ID_CASO_COBRANCA_REGUA_ETAPA
    );

    // useEffect(() => {
    //     setIdCasoCobrancaReguaEtapa(props.ID_CASO_COBRANCA_REGUA_ETAPA);
    // }, [props.ID_CASO_COBRANCA_REGUA_ETAPA]);

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const rowTable = (cell: any, row: IAcoesReguaEtapa) => {
        return (
            <div
                className="card card-custom w-auto ml-auto wave wave-animate-slow wave-success border-bottom border-1 border-dark"
                key={row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO}
            >
                <div className="card-body p-3">
                    <div className="d-flex align-itens-center justify-content-between mb-1">
                        <div>
                            <h1 className="font-weight-bolder font-size-normal">
                                <span className="h3 text-dark-75">
                                    {row.DS_NOME_ACAO}
                                </span>
                            </h1>
                        </div>
                        <div></div>
                    </div>
                    <div className="d-flex flex-wrap align-itens-center justify-content-between mb-1">
                        <div className="d-flex flex-wrap  mr-1">
                            <div className="d-flex flex-wrap flex-column justify-content-center align-itens-center mr-1">
                                <span className="d-block font-weight-bold ">
                                    Nome Régua:
                                </span>
                                <span className="label label-dark  label-inline mr-2 my-1">
                                    {props.DadosRegua?.DS_NOME_REGUA}
                                </span>
                            </div>
                            <div className="d-flex flex-wrap flex-column justify-content-center align-itens-center mr-1">
                                <span className="d-block font-weight-bold ">
                                    Tipo Ação:
                                </span>
                                <span className="label label-dark  label-inline mr-2 my-1">
                                    {row.DS_TIPO_ACAO}
                                </span>
                            </div>
                            <div className="d-flex flex-wrap flex-column justify-content-center align-itens-center mr-1">
                                <span className="d-block font-weight-bold ">
                                    Etapa:
                                </span>
                                <span className="label label-dark  label-inline mr-2 my-1">
                                    {row.DS_NOME_ETAPA}
                                </span>
                            </div>
                        </div>

                        <div className="d-flex flex-wrap">
                            <button
                                type="button"
                                className="btn btn-light-primary border border-primary font-weight-bold m-1 d-flex align-items-center"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <ModalGerenciarFiltroAcao
                                                idAcaoEtapa={
                                                    row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO
                                                }
                                            />
                                        ),
                                        headerComponent:
                                            "Filtros Da Ação Selecionada",
                                        IconHeader: faFilter,
                                        size: "xl",
                                        scrollable: true,
                                    });
                                }}
                            >
                                Gerenciar
                            </button>
                            <button
                                type="button"
                                className="btn btn-light-primary border border-primary font-weight-bold m-1 d-flex align-items-center"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <ModalVisualizarDados row={row} />
                                        ),
                                        headerComponent: "Dados Filtros Ação",
                                        IconHeader: faDatabase,
                                        size: "xl",
                                        scrollable: true,
                                    });
                                }}
                            >
                                Visualizar Dados
                            </button>
                            <button
                                className="btn btn-light-primary border border-primary font-weight-bold m-1"
                                disabled={!row.FL_ACAO_AGENDADA}
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <ModalAgendamento row={row} />
                                        ),
                                        headerComponent: "Agendamento",
                                        IconHeader: faCalendarAlt,
                                        size: "lg",
                                        scrollable: true,
                                    });
                                }}
                            >
                                Agendamento
                            </button>
                            <button
                                type="button"
                                className="btn btn-light-primary border border-primary font-weight-bold m-1 d-flex align-items-center"
                                disabled={row.ID_TIPO_ACAO !== 3}
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <ModalOrdemAcao row={row} />
                                        ),
                                        headerComponent: "Ordem Da Ação",
                                        IconHeader: faSortNumericUpAlt,
                                        size: "xl",
                                        scrollable: true,
                                    });
                                }}
                            >
                                Ordenar
                            </button>
                            <button
                                type="button"
                                className="btn btn-light-primary border border-primary font-weight-bold m-1 d-flex align-items-center"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Component: () => (
                                            <ModalEditarAcoes
                                                idAcaoEtapa={
                                                    row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO
                                                }
                                                idEtapaRegua={
                                                    idCasoCobrancaReguaEtapa
                                                }
                                                updateList={
                                                    props.updateListAcoesReguaPorEtapa
                                                }
                                                setShow={setShow}
                                            />
                                        ),
                                        headerComponent: "Editar Ações",
                                        IconHeader: faEdit,
                                        size: "xl",
                                        scrollable: true,
                                    });
                                }}
                            >
                                Editar
                            </button>
                            <button
                                className="btn btn-light-danger border border-danger font-weight-bold m-1"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar esta ação da régua?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            DeletarAcaoReguaContoller(
                                                row.ID_CASO_COBRANCA_REGUA_ETAPA_ACAO
                                            ).then(() => {
                                                props.updateListAcoesReguaPorEtapa();
                                            });
                                        }
                                    });
                                }}
                            >
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME_ACAO",
            text: "Ações da Etapa",
            formatter: rowTable,
            headerClasses: "font-size-h8 font-weight-bold",
            classes: "p-3 ws-nowrap",
        },
    ];

    return props.DadosRegua ? (
        <>
            <div className="form-group row d-flex justify-content-between align-items-center">
                <div className="col-lg-3">
                    <label>Selecione uma Etapa</label>
                    {props.cadastroEtapaReguaLoading ||
                    props.updateListReguaEtapaLoading ? (
                        <SpinnerComponent />
                    ) : (
                        <LazySelect
                            className="form-control"
                            controller={props.ListarReguaEtapa}
                            getDS={(re) => re.DS_NOME_ETAPA}
                            getKeyValue={(re) =>
                                re.ID_CASO_COBRANCA_REGUA_ETAPA
                            }
                            name="ID_REGUA_ETAPA"
                            // onOptionsLoad={(res) => {
                            //     console.log(res[0]);

                            //     if (res[0]) {
                            //         props.setID_CASO_COBRANCA_REGUA_ETAPA(
                            //             res[0].ID_CASO_COBRANCA_REGUA_ETAPA
                            //         );
                            //     }
                            // }}
                            value={idCasoCobrancaReguaEtapa}
                            onChange={(e) => {
                                ListarAcoesReguaPorEtapaController(
                                    Number.parseInt(e.target.value)
                                ).then((res) => {
                                    props.setLstAcoesEtapaRegua(res);
                                });
                                setIdCasoCobrancaReguaEtapa(
                                    Number(e.target.value)
                                );
                                props.setID_CASO_COBRANCA_REGUA_ETAPA(
                                    Number(e.target.value)
                                );
                            }}
                        >
                            {props.ID_CASO_COBRANCA_REGUA_ETAPA &&
                            props.ID_CASO_COBRANCA_REGUA_ETAPA > 0 ? (
                                <></>
                            ) : (
                                <option value={undefined}></option>
                            )}
                        </LazySelect>
                    )}
                </div>
                <div>
                    <button
                        className="btn btn-success font-weight-bold"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                Component: () => (
                                    <ModalCadastrarAcaoEtapa
                                        idEtapaRegua={idCasoCobrancaReguaEtapa}
                                        updateList={
                                            props.updateListAcoesReguaPorEtapa
                                        }
                                        setShow={setShow}
                                    />
                                ),
                                noFooter: true,
                                noHeader: true,
                            });
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faPlus}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Nova Ação
                    </button>
                </div>
            </div>
            <div>
                {props.LstAcoesEtapaRegua && (
                    <Table
                        columns={columns}
                        data={props.LstAcoesEtapaRegua}
                        keyField={"ID_CASO_COBRANCA_REGUA_ETAPA_ACAO"}
                        bordered={false}
                    />
                )}
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    ) : (
        <SpinnerComponent />
    );
}
